/* eslint-disable react/prop-types */
import { Suspense } from "react";
import CustomInput from "../CustomInput/CustomInput";

const DynamicInformationForm = ({ informationFormData }) => {
	return (
		<div
			className="dynamic-information-form-container"
			id="dynamic-information-form-container"
			style={{ marginTop: "2rem" }}
		>
			{informationFormData &&
				informationFormData.map((eachItem, index) => {
					const { label, name, value } = eachItem;
					return (
						<div className="details-form-row" key={index}>
							<div className="details-form-label">{label}</div>
							<Suspense fallback={<div />}>
								<CustomInput name={name} value={value} disabled={true} />
							</Suspense>
						</div>
					);
				})}
		</div>
	);
};

export default DynamicInformationForm;
